import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BASE_PERMISSIONS } from '../../../core/constants/base-permissions';
import { BaseRolesService } from '../../../core/services/base-roles.service';
import { baseAssignmentsActions, baseAssignmentsSelectors, BaseCoreState } from '../../../_store';

@Injectable({ providedIn: 'root' })
export class BaseUpcomingMLPAssignmentsGuard {
  constructor(private readonly store: Store<BaseCoreState>, private rolesService: BaseRolesService) {}

  canActivate(): Observable<boolean> | boolean {
    if (!this.rolesService.hasFeaturePermission(BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS)) {
      return true;
    }

    this.store.dispatch(baseAssignmentsActions.loadUpcomingMLPAssignments());

    return this.store.select(baseAssignmentsSelectors.getUpcomingMLPAssignments).pipe(
      filter((state) => state.ok !== undefined),
      map((state) => state.ok as boolean)
    );
  }
}
